module.exports = __webpack_public_path__ + "img/clg-block-bg-1.bef65bbc.png";